import React from 'react'
import { Section, Title, Copy } from './index.styled'
import { LocaleContext } from 'styles/locale-provider'

const BottomBlackSection = ({ className }) => {
  const { lang } = React.useContext(LocaleContext)

  const text =
    lang === 'es'
      ? [
          'Descubre Kanai',
          'Cada resort en Kanai ofrece una experiencia única, pensada para enriquecer cuerpo, mente y espíritu. Aunque cada uno tiene su propio carácter, todos comparten un compromiso con la excelencia: un servicio impecable, un diseño que eleva la calidad de vida, un profundo respeto por el entorno natural, espacios de bienestar de clase mundial y una propuesta gastronómica tan diversa como exquisita.',
        ]
      : [
          'Discover Kanai',
          'Each of Kanai’s resorts offers a distinct stay and unique experiences. What all of the resorts have in common are uncompromising service, quality-of-life-improving design, reverence for the natural environment, world-class spa, wellness and fitness facilities, and superb, varied cuisine.',
        ]

  return (
    <Section className={[className, 'black'].join(' ')}>
      <Title className="fadeIn">{text[0]}</Title>
      <Copy className="fadeIn">{text[1]}</Copy>
    </Section>
  )
}

export default BottomBlackSection
